import { Badge, BadgeVariant, Box } from '@palmetto/palmetto-components';

interface PropertyValueProps {
  label: string;
  value: any;
  isBadgeValue?: boolean;
  variantBadgeValue?: BadgeVariant;
}

export const PropertyValue = ({ label, value, isBadgeValue, variantBadgeValue }: PropertyValueProps) => (
  <Box
    direction="row"
    alignItems="baseline"
    justifyContent="space-between"
    borderWidth="0 0 xs 0"
    borderColor="separator"
    padding="0 0 xs 0"
    gap="md"
  >
    <Box minWidth={{ desktop: '2xl' }} fontWeight="medium">
      {label}
    </Box>
    <Box direction="row" childGap="xs" alignItems="center">
      {isBadgeValue ? <Badge variant={variantBadgeValue} message={value} /> : value}
    </Box>
  </Box>
);
